import React from 'react';
import Par from '../../../comum/containers/par';

const ModalVisualizaHistoricoDacaDevolucao = (props) => {
	const {
		transacao,
	} = props;

	return (
		<div className='col-md-12 pl-0 pr-0'>
			{transacao.nome !== null && (
				<React.Fragment>

					<div className='d-flex'>
						<Par label='Item' value={transacao.daca.nome} />
						<Par label='Tipo de transação' value='Devolução' />
					</div> {/* d-flex */}

					<div className='d-flex'>
						<Par label='Origem' value={transacao.origemEmprestimo} />
						<Par label='Destino' value={transacao.destino} />
					</div> {/* d-flex */}

					<div className='d-flex'>
						<Par label='Quantidade' value={transacao.quantidadeEntradaSaida} />
						<Par label='Data de devolução' value={transacao.dataCadastro} />

					</div>

				</React.Fragment>
			)}
		</div>
	);
};

export default ModalVisualizaHistoricoDacaDevolucao;
